module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isPhoneView) ? _c('multipane', {
    staticClass: "vertical-panes",
    attrs: {
      "layout": "vertical"
    }
  }, [_c('div', {
    staticClass: "pane",
    style: ({
      width: '50%'
    })
  }, [_c('v-select', {
    attrs: {
      "name": "serviceid",
      "items": _vm.services,
      "disabled": _vm.DisableCheckComponents,
      "item-text": "displayname",
      "item-value": "id",
      "label": "Choose Service",
      "light": ""
    },
    on: {
      "change": function($event) {
        _vm.getChosenServiceDetails()
      }
    },
    model: {
      value: (_vm.chosenserviceid),
      callback: function($$v) {
        _vm.chosenserviceid = $$v
      },
      expression: "chosenserviceid"
    }
  }), _vm._v("\nService Name: " + _vm._s(_vm.chosenservice.name) + "\n"), _c('br'), _vm._v("\nService Description: "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.chosenservice.description)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showIMEIBox) ? _c('v-textarea', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "label": "IMEIs"
    },
    model: {
      value: (_vm.imeilist),
      callback: function($$v) {
        _vm.imeilist = $$v
      },
      expression: "imeilist"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showOrderButton) ? _c('toggle-button', {
    attrs: {
      "value": false,
      "disabled": _vm.DisableCheckComponents,
      "color": "#82C7EB",
      "width": 65,
      "sync": true,
      "labels": {
        checked: 'Instant',
        unchecked: 'Order'
      }
    },
    model: {
      value: (_vm.instantcheck),
      callback: function($$v) {
        _vm.instantcheck = $$v
      },
      expression: "instantcheck"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderButton) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "color": "info"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1), _vm._v(" "), _c('multipane-resizer'), _vm._v(" "), _c('div', {
    staticClass: "pane",
    style: ({
      flexGrow: 1
    })
  }, [(!_vm.instantcheck) ? _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearLog($event)
      }
    }
  }, [_vm._v("Clear Log")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n Progress: " + _vm._s(_vm.qtydone) + "/" + _vm._s(_vm.totalsubmitted) + "\n "), _c('div', {
    directives: [{
      name: "overflow-scroll",
      rawName: "v-overflow-scroll",
      value: (true),
      expression: "true"
    }],
    staticClass: "msg-container",
    attrs: {
      "scroll-to": "last-child"
    }
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      staticClass: "msg"
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1) : _c('multipane', {
    staticClass: "horizontal-panes",
    attrs: {
      "layout": "horizontal"
    }
  }, [_c('div', {
    staticClass: "pane",
    style: ({
      width: '90%'
    })
  }, [_c('v-select', {
    attrs: {
      "name": "serviceid",
      "items": _vm.services,
      "item-text": "displayname",
      "item-value": "id",
      "label": "Choose Service",
      "light": ""
    },
    on: {
      "change": function($event) {
        _vm.getChosenServiceDetails()
      }
    },
    model: {
      value: (_vm.chosenserviceid),
      callback: function($$v) {
        _vm.chosenserviceid = $$v
      },
      expression: "chosenserviceid"
    }
  }), _vm._v("\nService Name: " + _vm._s(_vm.chosenservice.name) + "\n"), _c('br'), _vm._v("\nService Description: "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.chosenservice.description)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showIMEIBox) ? _c('v-textarea', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "label": "IMEIs"
    },
    model: {
      value: (_vm.imeilist),
      callback: function($$v) {
        _vm.imeilist = $$v
      },
      expression: "imeilist"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showOrderButton) ? _c('toggle-button', {
    attrs: {
      "value": false,
      "color": "#82C7EB",
      "width": "65",
      "sync": true,
      "labels": {
        checked: 'Instant',
        unchecked: 'Order'
      }
    },
    model: {
      value: (_vm.instantcheck),
      callback: function($$v) {
        _vm.instantcheck = $$v
      },
      expression: "instantcheck"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOrderButton) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.DisableCheckComponents,
      "color": "info"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Submit Order")]) : _vm._e()], 1), _vm._v(" "), _c('multipane-resizer'), _vm._v(" "), _c('div', {
    staticClass: "pane",
    style: ({
      flexGrow: 1
    })
  }, [(!_vm.instantcheck) ? _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearLog($event)
      }
    }
  }, [_vm._v("Clear Log")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n Progress: " + _vm._s(_vm.qtydone) + "/" + _vm._s(_vm.totalsubmitted) + "\n "), _c('div', {
    directives: [{
      name: "overflow-scroll",
      rawName: "v-overflow-scroll",
      value: (true),
      expression: "true"
    }],
    staticClass: "msg-container",
    attrs: {
      "scroll-to": "last-child"
    }
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      staticClass: "msg"
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1), _vm._v(" "), _c('confirm-dialog', {
    attrs: {
      "dialog": _vm.showDialog,
      "dialogTitle": _vm.dialogTitle,
      "dialogText": _vm.dialogText
    },
    on: {
      "onConfirm": _vm.onConfirm,
      "onCancel": _vm.onCancel
    }
  }), _vm._v(" "), (_vm.loading === false) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.notice) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e8cc328","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PlaceOrder.vue
// module id = 398
// module chunks = 1